import { DateRangePicker, Input, Select, Text, type TypeSelectOption } from '@thefarmersfront/kitchen';

import clsx from 'clsx';
import dayjs from 'dayjs';

import { SearchFilter } from '~/components/common';

import {
  COLLECTING_CANDIDATE_FIXED_COURIER_OPTION,
  COLLECTING_CANDIDATE_FIXED_ORDER_STATUS_OPTION,
} from '~/constants/delivery-agency';

import type {
  CollectingRequestCandidateFilterOptions,
  CollectingRequestCandidateFilterValues,
  CollectingRequestCandidateFilterValuesStatus,
} from '~/types/delivery-agency.types';

import styles from './CollectingRequestCandidateFilter.module.scss';

const CollectingRequestCandidateFilter = ({
  options,
  values,
  valuesStatus,
  onChange,
  onChangeStatus,
  onSearch,
  onReset,
}: {
  options: CollectingRequestCandidateFilterOptions;
  values: CollectingRequestCandidateFilterValues;
  valuesStatus: CollectingRequestCandidateFilterValuesStatus;
  onChange: (values: Partial<CollectingRequestCandidateFilterValues>) => void;
  onChangeStatus: (values: Partial<CollectingRequestCandidateFilterValuesStatus>) => void;
  onSearch: () => void;
  onReset: () => void;
}) => {
  return (
    <SearchFilter formId="collecting-request-candidate-search-form" layout="flow" onSubmit={onSearch} onReset={onReset}>
      <div className={clsx(styles['filter-container'], styles['filter-keyword'])}>
        <Text size="small" weight="semi-bold" element="p">
          키워드
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.searchKeywordTypes}
            value={values.keywordType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => {
              if (value?.value === values.keywordType?.value) return;
              onChange({ keywordType: value, keyword: '' });
              onChangeStatus({ keyword: 'default' });
            }}
          />
          <Input
            type="text"
            size="small"
            placeholder="입력"
            maxLength={50}
            value={values.keyword}
            status={valuesStatus.keyword}
            onChange={(e) => onChange({ keyword: e.target.value })}
            onBlur={(e) => onChange({ keyword: e.target.value.trim() })}
            onFocus={() => onChangeStatus({ keyword: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-date'])}>
        <Text size="small" weight="semi-bold" element="p">
          배송 예정일
        </Text>
        <div className={styles['input-container']}>
          <DateRangePicker
            size="small"
            placeholder={{ start: '시작일', end: '종료일' }}
            minDate={dayjs().subtract(1, 'month').startOf('month').toDate()}
            maxDate={dayjs().endOf('day').toDate()}
            value={values.estimatedDeliveryDateRange}
            status={valuesStatus.estimatedDeliveryDateRange}
            onChange={(value) => onChange({ estimatedDeliveryDateRange: value })}
            onFocus={() => onChangeStatus({ estimatedDeliveryDateRange: 'default' })}
          />
        </div>
      </div>
      <div className={styles['filter-container']}>
        <Text size="small" weight="semi-bold" element="p">
          배송사
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            disabled
            options={[COLLECTING_CANDIDATE_FIXED_COURIER_OPTION]}
            value={COLLECTING_CANDIDATE_FIXED_COURIER_OPTION}
          />
        </div>
      </div>
      <div className={styles['filter-container']}>
        <Text size="small" weight="semi-bold" element="p">
          배송 상태
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            disabled
            options={[COLLECTING_CANDIDATE_FIXED_ORDER_STATUS_OPTION]}
            value={COLLECTING_CANDIDATE_FIXED_ORDER_STATUS_OPTION}
          />
        </div>
      </div>
    </SearchFilter>
  );
};

export default CollectingRequestCandidateFilter;
